import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatTableDataSource, MatSort, MatPaginator, MatDialogRef } from '@angular/material';
import { HrDashboardService } from '../../../service/hr-dashboard/hr-dashboard.service';
import { Pagination } from 'src/app/utility/services/paging/paging';

@Component({
  selector: 'app-dialoge-dashboard-detail',
  templateUrl: './dialoge-dashboard-detail.component.html',
  styleUrls: ['./dialoge-dashboard-detail.component.scss']
})
export class DialogeDashboardDetailComponent implements OnInit {

  dataSource = new MatTableDataSource();
  columns: string[] = ['sl', 'claimNumber', 'employeeName', 'patientName', 'relation'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  public pagination = new Pagination();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private queueService: HrDashboardService,
    private dialogRef: MatDialogRef<DialogeDashboardDetailComponent>
  ) { }

  ngOnInit() {
    this.getGridData(false);
  }

  load(data) {
    this.pagination.totalCount = data.length > 0 ? data[0]['total'] : 0 ;
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.sort = this.sort;
  }

  getGridData(isSearchObj: boolean){
    const obj = this.createSearchObject(isSearchObj);
    this.queueService.getDetailedReportByHr(this.createSearchObject(isSearchObj)).subscribe(res => {
      this.load(res);
    }, err => {

    });
  }

  ChangePage($event) {
    this.pagination.pageSize = $event.pageSize;
    this.pagination.pageIndex = $event.pageIndex;
    this.getGridData(true);
  }

  applyFilter(text) {
    this.pagination = new Pagination();
    this.pagination.searchText = text;
    this.getGridData(true);
  }

  createSearchObject(isSearchObj: boolean){
    return{
      fromDate: this.data.fromDate,
      toDate: this.data.toDate,
      queryType: this.data.queryType,
      pageIndex: isSearchObj? this.pagination.pageIndex : 0,
      pageSize: isSearchObj? this.pagination.pageSize : 10,
      searchText: isSearchObj? this.pagination.searchText : ''
    }
  }

  getHeader(){
    if(this.data.queryType == 'SUBMITTED')
      return 'Submitted Claims';
    else if(this.data.queryType == 'PENDING')
      return 'Pending Claims';
    else if (this.data.queryType == 'DECLINED')
      return 'Declined Claims';
    else
      return 'Paid Claims';
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
}
